
































import { Component, Mixins, Prop } from "vue-property-decorator";
import PasswordComponent from "../../../../commoncomponents/passwordcomponent/PasswordComponent.vue";
import config from "@/config";
import { PassObj, TypeObj } from "@/Model/model";
import commonEntryStore from "@/store/modules/commonEntry";
import passwordStore from "@/store/modules/password";
import APP_CONST from "@/constants/AppConst";
import applicationStore from "@/store/modules/applications/applicationStore";
import AccountSettings from "@/mixins/accountSettings.mixin";
import StripeModule from "@/store/modules/stripe/module";
import { getInstance } from "@/auth";
import Spinner from "@/commoncomponents/spinner/Spinner.vue";

@Component({
  components: {
    Spinner,
    "password-component": PasswordComponent,
  },
})
export default class SignIn extends Mixins(AccountSettings) {
  @Prop({ type: String, default: APP_CONST.APP_ROUTES.DASHBOARD.path })
  readonly redirect!: string;
  public typeobj: PassObj = config.loginPassObj;
  public passValidation = {
    oldPassword: -1,
    password: -1,
    confirmPassword: -1,
  };
  public loginProcessing: boolean = false;
  APP_CONST = APP_CONST;

  onClick() {
    this.$gtm &&
      this.$gtm.trackEvent({
        event: null,
        category: "Login Page",
        action: "click",
        label: "Login Page Click Event Activated",
        value: 5000,
        noninteraction: false,
      });
  }

  /* istanbul ignore next */
  mounted() {
    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path);
    }
  }

  get accountName(): string {
    return commonEntryStore.accountDesignDetails.accountName;
  }

  /* istanbul ignore next */
  get email(): string {
    return commonEntryStore.guardianData.email;
  }

  /* istanbul ignore next */
  get submitResponse(): object {
    return commonEntryStore.getSubmit;
  }

  /* istanbul ignore next */
  get applicationData() {
    return applicationStore.applicationDataInfo;
  }

  /* istanbul ignore next */
  public async onSubmit() {
    this.loginProcessing = true;
    const email = this.email ? this.email.trim() : this.email;
    const objLoginData: any = {};
    objLoginData.type = this.typeobj.type;
    objLoginData.password = passwordStore.getPassword;
    this.passValidation.password = objLoginData.password.length;
    objLoginData.email = email;
    if (
      objLoginData.email.length !== APP_CONST.ZERO &&
      objLoginData.password.length !== APP_CONST.ZERO
    ) {
      const { loginWithRedirect } = getInstance();
      await StripeModule.createSetupIntent();
      loginWithRedirect({ targetUrl: this.redirect });
    }
    this.loginProcessing = false;
  }

  /* istanbul ignore next */
  beforeMount() {
    /* istanbul ignore else */
    if (commonEntryStore.guardianData && !commonEntryStore.guardianData.email) {
      this.$router.push(APP_CONST.APP_ROUTES.LOGIN);
    }
  }
}
